export default (ctx, inject) => {
  inject('periods', () => {
    return [
      {
        id: 1,
        keyword: 'today',
        period: 'day'
      },
      {
        id: 2,
        keyword: 'week',
        period: 'week'
      },
      {
        id: 3,
        keyword: 'month',
        period: 'month'
      },
      {
        id: 4,
        keyword: 'year',
        period: 'year'
      }
    ]
  })

  inject('toHourFormat', (epoch) => {
    if (!epoch) return ''

    const date = new Date(epoch * 1000)
    const options = { hour: 'numeric', minute: 'numeric', hour12: false }

    return date.toLocaleTimeString(ctx.app.i18n.locale, options)
  })

  inject('toDurationFormat', (durationInSeconds) => {
    if (!durationInSeconds) return ''

    const hours = Math.floor(durationInSeconds / 3600)
    durationInSeconds -= hours * 3600
    const minutes = Math.floor(durationInSeconds / 60)
    durationInSeconds -= minutes * 60

    let formattedHours = ''
    let formattedMinutes = ''
    let formattedSeconds = ''

    if (hours > 0) formattedHours = `${hours}${ctx.app.i18n.t('hour_suffix')}`

    if (minutes > 0)
      formattedMinutes = `${minutes}${ctx.app.i18n.t('minutes_suffix')}`

    if (durationInSeconds > 0)
      formattedSeconds = `${durationInSeconds}${ctx.app.i18n.t(
        'seconds_suffix'
      )}`

    return `${formattedHours} ${formattedMinutes} ${formattedSeconds}`
  })

  inject('getEnergyKind', (type) => {
    if (!type || type === '') {
      return null
    }
    switch (type) {
      case 'grid':
        return 'consumed'
      case 'solar':
        return 'generated'
      case 'currency':
        return 'consumed'
      default:
    }
  })

  inject('tabItems', (type, showDay) => {
    if (!type || type === '') {
      return null
    }
    switch (type) {
      case 'period': {
        const mappedPeriods = ctx.app.$periods().map((p) => {
          return {
            id: p.id,
            text: ctx.app.i18n.t(p.keyword),
            averageLabel: ctx.app.i18n.t(p.keyword + '_average'),
            _period: p.period
          }
        })

        if (showDay) {
          mappedPeriods[0].text = ctx.app.i18n.t('day')
        }

        return mappedPeriods
      }
      case 'forecast':
        return [
          {
            id: 1,
            text: ctx.app.i18n.t('endOfMonth'),
            _period: 'month'
          },
          {
            id: 2,
            text: ctx.app.i18n.t('endOfYear'),
            _period: 'year'
          }
        ]
      default:
    }
  })
  inject('getConsumptionFormat', (type) => {
    if (!type || type === '') {
      return null
    }
    switch (type) {
      case 'grid':
        return {
          id: 1,
          value: false,
          text: 'grid',
          icon: 'electricity',
          color: ctx.app.$chartLegendColor('grid'),
          _format: 'energy'
        }
      case 'solar':
        return {
          id: 2,
          value: null,
          text: 'solar',
          icon: 'sun',
          color: ctx.app.$chartLegendColor('solar'),
          _format: 'energy'
        }
      case 'currency':
        return {
          id: 3,
          value: true,
          text: 'currency',
          icon: ctx.app.$currency.getIcon(),
          color: ctx.app.$chartLegendColor('currency'),
          _format: 'currency'
        }
      default:
    }
  })

  inject('getEnergyComparison', (data, kind) => {
    if (!data || !kind) {
      return null
    }

    const items = []
    switch (kind) {
      case 'grid':
        if (data.expected) {
          items.push({
            text: ctx.app.i18n.t('expected'),
            value: data.expected,
            color: ctx.app.$chartLegendColor('expected')[1]
          })
        }
        if (data.current) {
          items.push({
            text: ctx.app.i18n.t('current'),
            value: data.current,
            color: ctx.app.$chartLegendColor('forecast')
          })
        }
        return items
      case 'solar':
        if (data.expected) {
          items.push({
            text: ctx.app.i18n.t('expected'),
            value: data.expected,
            color: ctx.app.$chartLegendColor('expected-solar')[1]
          })
        }
        if (data.current) {
          items.push({
            text: ctx.app.i18n.t('current'),
            value: data.current,
            color: ctx.app.$chartLegendColor('forecast-solar')
          })
        }
        return items
      case 'currency':
        if (data.expected) {
          items.push({
            text: ctx.app.i18n.t('expected'),
            value: data.expected,
            color: ctx.app.$chartLegendColor('expected-currency')[1]
          })
        }
        if (data.current) {
          items.push({
            text: ctx.app.i18n.t('current'),
            value: data.current,
            color: ctx.app.$chartLegendColor('forecast-currency')
          })
        }
        return items
      default:
    }
  })

  inject('liveLabels', () => {
    const labels = []

    for (let i = 60; i >= 0; i--) {
      if (i === 0) {
        labels.push(ctx.app.i18n.t('now'))
      } else {
        // labels.push(`${i.toString()} ${ctx.app.i18n.t('min_ago')}`)
        labels.push(ctx.app.i18n.t('min_ago', [i.toString()]))
      }
    }

    return labels
  })

  inject('labelsByPeriod', (epochs, period) => {
    const labels = []

    if (epochs && epochs.length) {
      for (let i = 0; i < epochs.length; i++) {
        switch (period) {
          case 'day': {
            const zeroPad = (num, places) => String(num).padStart(places, '0')
            labels.push(`${zeroPad(i, 2)}:00`)
            break
          }
          case 'week':
          case 'month':
            labels.push(ctx.app.$formatEpochToDayOfMonth(epochs[i]))
            break
          case 'year':
            labels.push(ctx.app.$formatEpochToMonth(epochs[i]))
            break
        }
      }
    }

    return labels
  })

  inject('dayLabels', () => {
    const labels = []

    for (let i = 0; i < 24; i++) {
      labels.push(ctx.app.$formatAmPm(i))
    }

    return labels
  })

  inject('monthLabels', () => {
    const labels = []

    for (let i = 1; i < 30; i++) {
      labels.push(i.toString())
    }

    return labels
  })

  inject('toSecondsFromEpoch', (date) => {
    return date.getTime() / 1000
  })

  inject('formatCurrency', (value, fixedLocale) => {
    if (value || value === 0) {
      return value.toLocaleString(fixedLocale || ctx.app.i18n.locale, {
        maximumFractionDigits: 2,
        useGrouping: false
      })
    }
    return ''
  })

  inject('getPercentage', (value1, value2) => {
    if (value1 && value2) {
      return value1 / value2
    }
    return 0
  })

  inject('formatEnergy', (value, fixedLocale) => {
    if (value || value === 0) {
      return value.toLocaleString(fixedLocale || ctx.app.i18n.locale, {
        maximumFractionDigits: 2
      })
    }
    return ''
  })

  inject('formatAbsolutePercentage', (value, fixedLocale) => {
    if (value || value === 0) {
      return `${Math.abs(value).toLocaleString(
        fixedLocale || ctx.app.i18n.locale,
        {
          maximumFractionDigits: 0
        }
      )}%`
    }

    return ''
  })

  inject('formatPercentage', (value, fixedLocale) => {
    if (value || value === 0) {
      return `${value.toLocaleString(fixedLocale || ctx.app.i18n.locale, {
        maximumFractionDigits: 0
      })}%`
    }

    return ''
  })

  inject('capitaliseString', (value) => {
    if (value || value === 0) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    }

    return ''
  })

  inject('statusFunctionality', (percentile, isForecastAndSolar) => {
    if (percentile === null || percentile === '') {
      return null
    }

    if (isNaN(percentile)) {
      return {
        text: ctx.app.i18n.t('live'),
        layout: ctx.app.$statusStyle('live')
      }
    }

    const value = parseFloat(percentile.toFixed(0))
    // console.log(value)
    // console.log(isForecastAndSolar)
    if (value === 0) {
      return {
        text: '0%',
        layout: ctx.app.$statusStyle('neutral')
      }
    } else if (
      (value > 0 && !isForecastAndSolar) ||
      (value < 0 && isForecastAndSolar)
    ) {
      return {
        text: `${isForecastAndSolar ? '' : '+'}${value}%`,
        layout: ctx.app.$statusStyle('negative', isForecastAndSolar)
      }
    } else {
      return {
        text: `${value}%`,
        layout: ctx.app.$statusStyle('positive', isForecastAndSolar)
      }
    }
  })

  inject('dropdownHourItems', () => {
    const zeroPad = (num, places) => String(num).padStart(places, '0')

    const now = new Date()
    const midnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    )
    const result = []
    for (let i = 0; i < 24; i++) {
      const iDate = new Date(midnight)
      iDate.setHours(i)

      const diff = iDate.getTime() - midnight.getTime()
      const diffSeconds = diff / 1000

      result.push({
        id: i * 2,
        name: `${zeroPad(i, 2)}:00`,
        value: diffSeconds
      })
      result.push({
        id: i * 2 + 1,
        name: `${zeroPad(i, 2)}:30`,
        value: diffSeconds + 1800
      })
    }
    return result
  })

  inject('forecastInfo', ({ percentile, type, period, savings }) => {
    /* console.log(
      'percentile: ',
      percentile,
      'type: ',
      type,
      'period: ',
      period,
      'savings:',
      savings
    ) */
    const forecastInfo = {}
    let positive = true
    if (percentile !== null && percentile !== undefined && type && period) {
      const fluctuation = ctx.app.$statusFunctionality(
        percentile,
        type.text === 'solar'
      )
      forecastInfo.fluctuation = {
        text: `${fluctuation.text} ${ctx.app.i18n.t('soFarThis', [
          ctx.app.i18n.t(period)
        ])}`,
        layout: fluctuation.layout
      }
      let translation
      switch (type.text) {
        case 'solar':
          translation =
            percentile < 0
              ? 'lessSolarThanForecasted'
              : 'moreSolarThanForecasted'
          positive = percentile > 0
          break
        case 'currency':
          translation =
            percentile < 0
              ? 'lessCurrencyThanForecasted'
              : 'moreCurrencyThanForecasted'
          positive = percentile < 0
          break
        default:
          translation =
            percentile < 0 ? 'lessGridThanForecasted' : 'moreGridThanForecasted'
          positive = percentile < 0
          break
      }
      forecastInfo.translation = ctx.app.i18n.t(translation, [
        `<strong>${ctx.app.$formatAbsolutePercentage(percentile)}</strong>`
      ])
    } else {
      return null
    }
    if (savings) {
      forecastInfo.translation += ' '
      forecastInfo.translation += ctx.app.i18n.t(
        positive ? 'savingsText' : 'lossText',
        [
          `<strong>${ctx.$formatUnit(
            type._format === 'energy'
              ? ctx.$formatEnergy(savings)
              : ctx.$formatCurrency(savings),
            type._format === 'energy'
              ? ctx.app.i18n.t('kwh')
              : ctx.$currency.get()
          )}</strong>`,
          ctx.app.i18n.t(period).toLowerCase()
        ]
      )
    }
    return forecastInfo
  })

  inject('unitsLeft', (unit) => {
    return ['£', '€'].includes(unit)
  })

  inject('formatUnit', (value, unit) => {
    return ctx.$unitsLeft(unit) ? `${unit} ${value}` : `${value} ${unit}`
  })

  inject('getPvOptimiseHeatingOptions', () => {
    return [
      {
        id: 1,
        text: ctx.app.i18n.t('yes'),
        icon: 'home-underfloor',
        value: 'UnderFloorHeating'
      },
      {
        id: 2,
        text: ctx.app.i18n.t('no'),
        icon: 'unknown',
        value: 'Unknown'
      }
    ]
  })

  inject('getEnergySavingUserMode', () => {
    return [
      { id: 0, text: ctx.app.i18n.t('standard'), _value: 'standard' },
      { id: 1, text: ctx.app.i18n.t('eco'), _value: 'eco' },
      { id: 2, text: ctx.app.i18n.t('supereco'), _value: 'super eco' }
    ]
  })

  inject('getLauncherAuthenticateUrl', (route) => {
    const redirect = 'launcher?status=authenticate'

    let onectaUrl
    let pwaUrl
    let clientId
    switch (process.env.envName) {
      case 'master':
        onectaUrl = process.env.apiOnectaDaikinMaster
        pwaUrl = process.env.pwaUrlMaster
        clientId = process.env.pwaOnectaClientIdMaster
        break
      case 'develop':
        onectaUrl = process.env.apiOnectaDaikinDevelop
        pwaUrl = process.env.pwaUrlDevelop
        clientId = process.env.pwaOnectaClientIdDevelop
        break
      case 'feature':
        onectaUrl = process.env.apiOnectaDaikinFeature
        pwaUrl = process.env.pwaUrlFeature
        clientId = process.env.pwaOnectaClientIdFeature
        break
      default:
        onectaUrl = process.env.apiOnectaDaikinStaging
        pwaUrl = process.env.pwaUrlStaging
        clientId = process.env.pwaOnectaClientIdStaging
    }

    pwaUrl += `${redirect}&scope=daikin.unified/control.basic`
    return `${onectaUrl}oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${pwaUrl}`
  })
}
